export default {"src":"/login-app/[GIT_HASH]/_next/static/media/sort_desc.3f8f3abf.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};